import {MetricEntry} from 'common/query-builder/query-entry-section/types';
import {MetricType, PRIMITIVE_MATH_TYPES, TopLevelMetricType} from 'common/types/reports/bookmark';
import {RestrictEntitySaving} from 'common/report/constants';
import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';

export function canSaveForPlan(currentProject: CurrentProject): boolean {
  return Boolean(currentProject?.canSaveEntity(RestrictEntitySaving.BehaviorMetrics));
}

export function getNewEntry({isExpanded}: {isExpanded: boolean}): MetricEntry {
  return {
    type: TopLevelMetricType.NewMetricEntry,
    behavior: {
      type: MetricType.Simple,
      name: null,
      behaviors: [
        {
          type: MetricType.Event,
          name: null,
          filters: [],
        },
      ],
    },
    measurement: {
      aggregationOperator: PRIMITIVE_MATH_TYPES.UNIQUE,
    },
    isExpanded,
  };
}
